import {
    FaWhatsapp,
    FaInstagram,
    FaFacebook,
    FaTiktok,
    FaYoutube,
    FaGlobe,
} from "react-icons/fa";

export const itemsList = [
    {
        id: "whatsapp",
        href: "https://wa.me/905013499688",
        text: "WhatsApp",
        icon: FaWhatsapp,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "website",
        href: "https://elmascoffee.com",
        text: "Online Store",
        icon: FaGlobe,
        showInIcons: true,
        showInButtons: false,
    },
    {
        id: "instagram",
        href: "https://www.instagram.com/elmas.coffees",
        text: "Instagram",
        icon: FaInstagram,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "facebook",
        href: "https://www.facebook.com/elmas.coffees",
        text: "Facebook",
        icon: FaFacebook,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "tiktok",
        href: "https://www.tiktok.com/@elmas.coffees",
        text: "TikTok",
        icon: FaTiktok,
        showInIcons: true,
        showInButtons: true,
    },
    {
        id: "youtube",
        href: "https://www.youtube.com/@elmas.coffees",
        text: "YouTube",
        icon: FaYoutube,
        showInIcons: true,
        showInButtons: true,
    },
];
